import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageProductList
 * @description
 * # manageProductList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'manageProductList',
    ($ngRedux, $rootScope, $scope, $location, $route, $timeout, $http, ENV) => {
      if (!$scope.isSuperUser) {
        $location.path('/');
      }

      $scope.processParams = () =>
        new Promise((resolve) => {
          const { productId } = $route.current.params;
          $scope.takeAction(productId);
          resolve(true);
        });

      $scope.takeAction = (id) => {
        if (!id) return;

        $scope
          .getProduct($http, ENV, id)
          .then(() => {
            $scope.open(id);
          })
          .catch(() => {
            const errorModalOptions = {
              heading: 'Product Error',
              message: `${id} is not available at this time.  It either does not exist or has caused an error.  Please try again later or contact support if the error persists.`,
              buttons: [
                {
                  label: 'Close',
                  href: '#',
                  clickFn: () => {
                    $rootScope.toggleErrorModal();
                    $location.path($rootScope.routes.product, false);
                  },
                },
              ],
            };
            $rootScope.toggleErrorModal(errorModalOptions);
          });
      };

      $scope.open = (id) => {
        const component = 'view-product';
        const closeRoute = $rootScope.previousRoute || $rootScope.routes.product;
        const beforeRoute = `${$rootScope.routes.product}/${id}`;

        $rootScope.openComponent({
          component: component,
          beforeRoute: beforeRoute,
          closeRoute: closeRoute,
        });
      };

      $scope.init = () => {
        $rootScope.previousRoute = $rootScope.routes.product;
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
        $scope.processParams();
      };

      $scope.table = {
        name: 'Manage Products',
        options: {
          endpoint: '/2.0/products/',
          endpoint_data_key: 'products',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'standard',
          scale_up: false,
          search_key: null,
          search_required: false,
        },
        actions: [],
        columns: [
          {
            name: 'Brand',
            options: {
              content: '{{ record.brand.name }}',
              class: 'minimum-width',
            },
          },
          {
            name: 'Dosage',
            options: {
              content: '{{ record.dosage_label }}',
              class: 'minimum-width',
            },
          },
          {
            name: 'Package',
            options: {
              content: '{{ record.package_label }}',
              class: 'minimum-width',
            },
          },
          {
            name: 'SKU',
            options: {
              content:
                '{{ record.sku }}<br /><em>{{ record.is_bonus_sku ? "Bonus SKU" : "" }}</em>',
              class: 'minimum-width',
            },
          },
          {
            name: 'Grouping Logic',
            options: {
              content:
                '<span style="text-transform: capitalize;">{{ record.grouping_logic }}</span>',
              class: 'minimum-width',
            },
          },
          {
            name: 'Species',
            options: {
              content:
                '<ul ng-if="record.species && record.species.length > 0"><li ng-repeat="species in record.species">{{ species.name }}</li></ul>',
              class: 'minimum-width',
            },
          },
          {
            name: 'Points',
            options: {
              content:
                'Base: {{ record.base_points }} <br><br><ul ng-if="record.tier_points"><li ng-repeat="(key, value) in record.tier_points">{{ key | capitalize }}: {{ value }}</li></ul>',
              class: 'minimum-width',
            },
          },
          {
            name: 'Start/End Dates',
            options: {
              content:
                '<span ng-if="record.start_date"><span style="font-weight: bold">Start Date:</span> {{ record.start_date }}<br ng-if="record.end_date" /></span><span ng-if="record.end_date"><span style="font-weight: bold">End Date:</span> {{ record.end_date }}</span><span ng-if="!record.start_date && !record.end_date">n/a</span>',
              class: '',
            },
          },
          {
            name: 'Action',
            options: {
              content: '<a href="#" ng-click="takeAction(record.id)">View Product</a>',
              class: 'td-action',
            },
          },
        ],
        filters: [
          {
            name: 'Brand',
            type: 'multiple_choice',
            options: {
              choices: {},
              choices_endpoint: '/2.0/products/brands/?paginate=false',
              choices_endpoint_data_key: 'brands',
              class: 'user-filter',
              name_attribute: 'name',
              no_selected_parameter: 'none',
              query_string_parameter: 'brands',
              select_all: true,
            },
          },
          {
            name: 'Species',
            type: 'multiple_choice',
            options: {
              choices: {
                Canine: { state: true, value: 1, order: 0 },
                Feline: { state: true, value: 2, order: 1 },
              },
              class: 'application-filter',
              query_string_parameter: 'species',
            },
          },
          {
            name: 'SKU Type',
            type: 'multiple_choice',
            options: {
              choices: {
                'Normal SKU': { state: true, value: false, order: 0 },
                'Bonus SKU': { state: true, value: true, order: 1 },
              },
              class: 'application-filter',
              query_string_parameter: 'is_bonus_sku',
            },
          },
        ],
        sort_options: {
          brand__name: {
            state: true,
            value: '1',
            title: 'Brand Name',
            order: 0,
          },
          is_bonus_sku: {
            state: true,
            value: '1',
            title: 'Bonus SKU',
            order: 1,
          },
          doses: {
            state: true,
            value: '1',
            title: 'Doses',
            order: 2,
          },
          contentstack_uid: {
            state: false,
            value: '-1',
            title: 'SKU',
            order: 3,
          },
        },
      };

      $scope.init();

      $scope.$on('$destroy', $scope.unsubscribe);
    },
  );
